import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

// export const exempleStyled = styled(estiloCriado).withConfig({
// 	shouldForwardProp: (prop) => !['nomeDaProps'].includes(prop)
// })``;
